<template>
  <div class="main-container">
    <h2 class="title">{{ title }}</h2>
    <div id="content-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true }
  }
}
</script>

<style>
h2 {
  color: #10367a;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  text-transform: uppercase;
  text-align: left;
}

.main-container {
  border-radius: 10px;
  width: 100%;
  padding: 30px 44px 55px 44px;
  background: #f9f9f9;
  margin-bottom: 35px;
}

.title {
  color: #10367a;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  text-transform: uppercase;
  text-align: left;
}

#content-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow: hidden;
}
</style>
